import createVueApp from '@/common/createApp'
import sidebar from '@/config/sidebars/mlap'

Styxie.Initializers.MlapSettingsGoogleAds = {
  show: async(props) => {
    const { default: GoogleAdsSettings } = await import('@/vue_widgets/mlap/settings/google_ads/index.vue')
    createVueApp(GoogleAdsSettings, { props, sidebar })
  }
}
